$(document).ready(function(){
    $('.fullIngredients').click(function(){
        $("html, body").animate({
            scrollTop: $(".collapsible-content").offset().top - 100
        }, 800);
        $('.collapsible-content .accordion:nth-child(4) .accordion__details').attr('open', true); 
    });
});



$(document).ready(function(){
    $('.fullIngredients-two').click(function(){
        $("html, body").animate({
            scrollTop: $(".collapsible-content").offset().top - 100
        }, 800);
        $('.collapsible-content .accordion:nth-child(1) .accordion__details').attr('open', true); 
    });
});



 

$(document).on('click', '.accent-color-text', function(e){
    var variant_title = $(this).find('.varient-title').text();
    $('li[data-img-type="variant"]').hide();
    $('li[data-alt="'+variant_title+'"]').show();
});

$(document).on('click', '.free-product-info-trigger', function(e){
    var $trigger = $(this);

    if(isFreeProductInfoTriggerDisabled($trigger)) {
        e.preventDefault();
        e.stopPropagation();
        $trigger.siblings('.free-product-info-popup').removeClass('is-visible');
        return;
    }

    e.stopPropagation();
    var $popup = $trigger.siblings('.free-product-info-popup');
    $('.free-product-info-popup').not($popup).removeClass('is-visible');
    positionPopupArrow($trigger, $popup);
    $popup.toggleClass('is-visible');
});

$(document).on('click', '.free-product-info-close', function(e){
    e.stopPropagation();
    $(this).closest('.free-product-info-popup').removeClass('is-visible');
});

$(document).on('click', function(e){
    if(!$(e.target).closest('.free-product-info-popup').length && !$(e.target).closest('.free-product-info-trigger').length) {
        $('.free-product-info-popup').removeClass('is-visible');
    }
});

$(document).on('mouseenter', '.free-product-info-trigger', function(e){
    var $trigger = $(this);
    var $popup = $trigger.siblings('.free-product-info-popup');

    if(isFreeProductInfoTriggerDisabled($trigger)) {
        $popup.removeClass('is-visible');
        return;
    }

    $('.free-product-info-popup').not($popup).removeClass('is-visible');
    positionPopupArrow($trigger, $popup);
    $popup.addClass('is-visible');
});

function isFreeProductInfoTriggerDisabled($trigger) {
    return $trigger.closest('label[aria-disabled="true"]').length > 0;
}

function positionPopupArrow($trigger, $popup) {
    var triggerOffset = $trigger.offset().left - $trigger.closest('.free-product-title-wrapper').offset().left;
    var arrowLeft = triggerOffset + $trigger.outerWidth() / 2;
    $popup.css('--arrow-left', arrowLeft + 'px');
}

$(document).on('mouseleave', '.free-product-title-wrapper', function(e){
    $(this).find('.free-product-info-popup').removeClass('is-visible');
});









// Animate numbers on scroll
        function animateValue(element, start, end, duration) {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                element.textContent = Math.floor(progress * (end - start) + start) + '%';
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        const percentageObserver = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && !entry.target.animated) {
                    entry.target.animated = true;
                    const value = parseInt(entry.target.textContent);
                    animateValue(entry.target, 0, value, 1500);
                }
            });
        }, { threshold: 0.5 });

        document.querySelectorAll('.result-percentage').forEach(el => {
            percentageObserver.observe(el);
        });



// Interactive timeline reveal 
   
        const timelineObserver = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const step = parseInt(entry.target.dataset.step);
                    
                    // Show current item
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                    
                    // Show next item after a delay if it exists
                    setTimeout(() => {
                        const nextItem = document.querySelector(`[data-step="${step + 1}"]`);
                        if (nextItem && window.scrollY > entry.target.offsetTop - window.innerHeight * 0.8) {
                            nextItem.style.opacity = '1';
                            nextItem.style.transform = 'translateY(0)';
                        }
                    }, 500);
                }
            });
        }, { 
            threshold: 0.3,
            rootMargin: '0px 0px -20% 0px'
        });

        document.querySelectorAll('.timeline-reveal').forEach(item => {
            timelineObserver.observe(item);
        });






 // =========================================
// Unified fullscreen function
// =========================================
function openFullscreen(vid) {
  if (!vid) return;

  if (vid.requestFullscreen) vid.requestFullscreen();
  else if (vid.webkitEnterFullscreen) vid.webkitEnterFullscreen(); // iPhone
  else if (vid.webkitRequestFullscreen) vid.webkitRequestFullscreen();
}

// =========================================
// Product Page Video Slider
// =========================================
(function () {

  let desktopSlidesPerRow = $('.product__video-slides-slider').data('desktopSlidesPerRow') || 4;

  if ($('.product__video-slides-slider').length) {
    $('.product__video-slides-slider').slick({
      infinite: false,
      slidesToShow: desktopSlidesPerRow,
      autoplay: false,
      prevArrow: `<button type="button" class="slider-button slider-button--prev">
        <svg aria-hidden="true" class="icon icon-caret" viewBox="0 0 10 6">
        <path d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>
      </button>`,
      nextArrow: `<button type="button" class="slider-button slider-button--next">
        <svg aria-hidden="true" class="icon icon-caret" viewBox="0 0 10 6">
        <path d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 00-.708z" fill="currentColor"/></svg>
      </button>`,
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 3, arrows: true }
        }
      ]
    });
  }

  // =========================================
  // VIDEO HELPERS
  // =========================================
  function showPlay($v) { $v.next('.product__video-slides-play-icon').removeClass('hidden'); }
  function hidePlay($v) { $v.next('.product__video-slides-play-icon').addClass('hidden'); }
  function showFs($v) { $v.prev('.product__video-slides-fullscreen-icon').removeClass('hidden'); }
  function hideFs($v) { $v.prev('.product__video-slides-fullscreen-icon').addClass('hidden'); }

  function pauseOthers(except) {
    $('.product__video-slides-slider video').each(function () {
      if (this !== except) {
        this.pause();
        showPlay($(this));
        hideFs($(this));
      }
    });
  }

  // =========================================
  // DELEGATED EVENT → Fix for slick cloned slides
  // =========================================
  $(document).on('click', '.product__video-slides-slider video', function (e) {
    const vid = this;
    const $v = $(vid);

    if (vid.paused) {
      pauseOthers(vid);
      vid.play();
      hidePlay($v);
      showFs($v);
    } else {
      vid.pause();
      showPlay($v);
      hideFs($v);
    }
  });

  // =========================================
  // FULLSCREEN ICON CLICK
  // =========================================
  $(document).on('click', '.product__video-slides-fullscreen-icon', function (e) {
    e.stopPropagation();
    const vid = $(this).next('video')[0];
    openFullscreen(vid);
  });

  // =========================================
  // FULLSCREEN CHANGE UPDATE ICONS
  // =========================================
  function onFullscreenChange() {
    const fsEl =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    $('.product__video-slides-slider video').each(function () {
      const $v = $(this);

      if (fsEl === this) {
        hidePlay($v);
        showFs($v);
      } else {
        if (this.paused) {
          showPlay($v);
          hideFs($v);
        }
      }
    });
  }

  $(document).on(
    'fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange',
    onFullscreenChange
  );

})();

// =========================================
// Pause all videos when slider changes
// =========================================
$('.product__video-slides-slider').on('beforeChange', function () {
  $('.product__video-slides-slider video').each(function () {
    this.pause();
  });
});


 
